(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var FONT_FAMILY = 'SymphonyChars';
  var CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var COLORS = ['#000000', '#ffffff'];
  var MAX_GLYPHS  = 12;
  var MAX_PHRASES = 1;
  var liveGlyphs  = 0;
  var livePhrases = 0;
  var dpr = Math.round(window.devicePixelRatio || 1);

  var layer = document.createElement('div');
  layer.className = 'symphony-glyph-layer';
  document.body.appendChild(layer);

  function rand(min, max) { return min + Math.random() * (max - min); }
  function randInt(min, max) { return Math.floor(rand(min, max + 1)); }
  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
  }
  function randColor() { return COLORS[Math.floor(Math.random() * COLORS.length)]; }
  function parseHex(hex) {
    var h = hex.replace('#', '');
    return [parseInt(h.slice(0,2),16), parseInt(h.slice(2,4),16), parseInt(h.slice(4,6),16)];
  }
  function fontStr(sz) { return 'normal ' + sz + 'px ' + FONT_FAMILY; }

  // Returns a canvas whose backing store is dpr× but displays at logW×logH CSS px
  function makeCanvas(logW, logH) {
    var c = document.createElement('canvas');
    c.width  = Math.round(logW * dpr);
    c.height = Math.round(logH * dpr);
    c.style.cssText = 'position:absolute;pointer-events:none';
    c.style.width  = logW + 'px';
    c.style.height = logH + 'px';
    return c;
  }

  // ── Single floating glyph ──────────────────────────────────────────────────

  function spawnGlyph() {
    if (liveGlyphs >= MAX_GLYPHS) return;

    var ch    = CHARS[Math.floor(Math.random() * CHARS.length)];
    var size  = randInt(14, 48);
    var color = randColor();
    var rgb   = parseHex(color);
    var revealFrames = randInt(14, 22);
    var holdFrames   = randInt(30, 70);
    var hideFrames   = randInt(16, 26);

    var pad  = 4;
    var logW = size + pad * 2;
    var logH = size + pad * 2;
    var physW = Math.round(logW * dpr);
    var physH = Math.round(logH * dpr);

    var off  = makeCanvas(logW, logH);
    var octx = off.getContext('2d');
    octx.scale(dpr, dpr);
    octx.font = fontStr(size);
    octx.fillStyle = color;
    octx.textBaseline = 'top';
    octx.fillText(ch, pad, pad);

    var src = octx.getImageData(0, 0, physW, physH).data;
    var pixels = [];
    for (var i = 0; i < src.length; i += 4) {
      if (src[i+3] > 10) pixels.push(i);
    }
    if (pixels.length === 0) return;

    liveGlyphs++;
    var canvas = makeCanvas(logW, logH);
    canvas.style.left = rand(3, 88) + 'vw';
    canvas.style.top  = rand(5, 88) + 'vh';
    layer.appendChild(canvas);
    var ctx  = canvas.getContext('2d');
    var disp = ctx.createImageData(physW, physH);

    shuffle(pixels);
    var revealIdx = 0;
    var perReveal = Math.ceil(pixels.length / revealFrames);

    function revealStep() {
      var end = Math.min(revealIdx + perReveal, pixels.length);
      for (var k = revealIdx; k < end; k++) {
        var pi = pixels[k];
        disp.data[pi]=rgb[0]; disp.data[pi+1]=rgb[1]; disp.data[pi+2]=rgb[2]; disp.data[pi+3]=255;
      }
      revealIdx = end;
      ctx.putImageData(disp, 0, 0);
      if (revealIdx < pixels.length) requestAnimationFrame(revealStep);
      else { holdLeft = holdFrames; requestAnimationFrame(holdStep); }
    }

    var holdLeft = 0;
    function holdStep() {
      if (holdLeft-- > 0) requestAnimationFrame(holdStep);
      else { shuffle(pixels); hideIdx = 0; requestAnimationFrame(hideStep); }
    }

    var hideIdx = 0;
    var perHide = Math.ceil(pixels.length / hideFrames);
    function hideStep() {
      var end = Math.min(hideIdx + perHide, pixels.length);
      for (var k = hideIdx; k < end; k++) disp.data[pixels[k]+3] = 0;
      hideIdx = end;
      ctx.putImageData(disp, 0, 0);
      if (hideIdx < pixels.length) requestAnimationFrame(hideStep);
      else { canvas.remove(); liveGlyphs--; }
    }

    requestAnimationFrame(revealStep);
  }

  // ── Phrase: multi-line, sequential per-char dissolve ──────────────────────

  function spawnPhrase() {
    if (livePhrases >= MAX_PHRASES) return;

    var roll = Math.random();
    var len = roll < 0.20 ? randInt(3, 9)
            : roll < 0.50 ? randInt(9, 22)
            : roll < 0.75 ? randInt(22, 40)
            :               randInt(40, 60);

    var size  = randInt(9, 15);
    var color = randColor();
    var rgb   = parseHex(color);
    var pad     = 2;
    var gap     = Math.max(1, Math.ceil(size * 0.12));
    var lineGap = Math.ceil(size * 0.45);
    var lineH   = size + lineGap;
    var charsPerLine = size <= 10 ? 16 : size <= 12 ? 13 : 10;

    var chars = [];
    for (var i = 0; i < len; i++) chars.push(CHARS[Math.floor(Math.random() * CHARS.length)]);

    var lines = [];
    for (var i = 0; i < chars.length; i += charsPerLine) {
      lines.push(chars.slice(i, Math.min(i + charsPerLine, chars.length)));
    }

    // Measure in logical pixels (measureText ignores context transform)
    var mctx = document.createElement('canvas').getContext('2d');
    mctx.font = fontStr(size);

    var lineWidths = lines.map(function (line) {
      return line.reduce(function (w, ch) { return w + Math.ceil(mctx.measureText(ch).width) + gap; }, 0);
    });

    var totalLogW = Math.max.apply(null, lineWidths) + pad * 2;
    var totalLogH = pad + lines.length * lineH + pad;
    var physTotalW = Math.round(totalLogW * dpr);
    var physTotalH = Math.round(totalLogH * dpr);

    // Build per-char pixel index sets in physical coords of the main canvas
    var allCharPixels = [];

    for (var li = 0; li < lines.length; li++) {
      var line = lines[li];
      var xLog = pad;
      var yLog = pad + li * lineH;

      for (var ci = 0; ci < line.length; ci++) {
        var ch    = line[ci];
        var cwLog = Math.ceil(mctx.measureText(ch).width) + gap;
        var chLog = size + 4;
        var physCW = Math.round(cwLog * dpr);
        var physCH = Math.round(chLog * dpr);

        var cOff  = makeCanvas(cwLog, chLog);
        var cctx  = cOff.getContext('2d');
        cctx.scale(dpr, dpr);
        cctx.font = fontStr(size);
        cctx.fillStyle = color;
        cctx.textBaseline = 'top';
        cctx.fillText(ch, 0, 0);

        var src   = cctx.getImageData(0, 0, physCW, physCH).data;
        var pxls  = [];
        var xPhys = Math.round(xLog * dpr);
        var yPhys = Math.round(yLog * dpr);

        for (var p = 0; p < src.length; p += 4) {
          if (src[p+3] > 10) {
            var bx = (p/4) % physCW;
            var by = Math.floor((p/4) / physCW);
            var mi = ((yPhys + by) * physTotalW + (xPhys + bx)) * 4;
            if (mi >= 0 && mi + 3 < physTotalW * physTotalH * 4) pxls.push(mi);
          }
        }
        shuffle(pxls);
        allCharPixels.push(pxls);
        xLog += cwLog;
      }
    }

    var totalPx = allCharPixels.reduce(function(a,b){return a+b.length;}, 0);
    if (totalPx === 0) return;

    livePhrases++;
    var canvas = makeCanvas(totalLogW, totalLogH);
    canvas.style.left = rand(2, 80) + 'vw';
    canvas.style.top  = rand(5, 82) + 'vh';
    layer.appendChild(canvas);
    var ctx  = canvas.getContext('2d');
    var disp = ctx.createImageData(physTotalW, physTotalH);

    var charIdx     = 0;
    var perCharFrames = 6;

    function typeNextChar() {
      if (charIdx >= allCharPixels.length) {
        holdLeft = randInt(60, 120);
        requestAnimationFrame(holdStep);
        return;
      }
      var pxls = allCharPixels[charIdx];
      if (pxls.length === 0) { charIdx++; typeNextChar(); return; }
      var perFrame = Math.max(1, Math.ceil(pxls.length / perCharFrames));
      var idx = 0;
      function step() {
        var end = Math.min(idx + perFrame, pxls.length);
        for (var k = idx; k < end; k++) {
          var pi = pxls[k];
          disp.data[pi]=rgb[0]; disp.data[pi+1]=rgb[1]; disp.data[pi+2]=rgb[2]; disp.data[pi+3]=255;
        }
        idx = end;
        ctx.putImageData(disp, 0, 0);
        if (idx < pxls.length) requestAnimationFrame(step);
        else { charIdx++; typeNextChar(); }
      }
      requestAnimationFrame(step);
    }

    var holdLeft = 0;
    function holdStep() {
      if (holdLeft-- > 0) requestAnimationFrame(holdStep);
      else {
        var all = [];
        for (var i = 0; i < allCharPixels.length; i++)
          for (var j = 0; j < allCharPixels[i].length; j++) all.push(allCharPixels[i][j]);
        shuffle(all);
        hidePixels = all;
        hideIdx = 0;
        perHide = Math.ceil(all.length / randInt(18, 28));
        requestAnimationFrame(hideStep);
      }
    }

    var hidePixels = [], hideIdx = 0, perHide = 1;
    function hideStep() {
      var end = Math.min(hideIdx + perHide, hidePixels.length);
      for (var k = hideIdx; k < end; k++) disp.data[hidePixels[k]+3] = 0;
      hideIdx = end;
      ctx.putImageData(disp, 0, 0);
      if (hideIdx < hidePixels.length) requestAnimationFrame(hideStep);
      else { canvas.remove(); livePhrases--; }
    }

    requestAnimationFrame(typeNextChar);
  }

  // ── Spawn loop ─────────────────────────────────────────────────────────────

  function spawnAny() {
    if (Math.random() < 0.5) spawnPhrase();
    else spawnGlyph();
  }

  function scheduleNext() {
    setTimeout(function () { spawnAny(); scheduleNext(); }, rand(300, 700));
  }

  document.fonts.load('normal 48px ' + FONT_FAMILY).then(function () {
    for (var i = 0; i < 4; i++) setTimeout(spawnAny, i * 200);
    scheduleNext();
  });
})();
